export enum Currency {
  eur = '€',
  usd = '$',
}
